import React, { forwardRef } from 'react'

import { CustomizableComponent } from '@contracts/components/customizableComponent'

import * as styles from './Container.module.scss'

interface Props extends CustomizableComponent {
	children: React.ReactNode
	type?: 'normal' | 'thin' | 'ultrathin' | 'wide'
}

const Container = forwardRef<HTMLDivElement, Props>((props, ref) => {
	const containerStyles = [styles.container]

	if (props.type && props.type !== 'normal') {
		containerStyles.push(styles[props.type])
	}

	if (props.className) {
		containerStyles.push(props.className)
	}

	return (
		<div className={containerStyles.join(' ')} ref={ref}>
			{props.children}
		</div>
	)
})

Container.defaultProps = {
	type: 'normal',
}

export default Container
